import { createSlice } from "@reduxjs/toolkit";
import api from "src/utils/axios";

const initialState = {
    isLoading: false,
    error: null,
    reservationHistory: [],
    tableSizesList: [],
};

const reservationSlice = createSlice({
    name: "reservation",
    initialState,
    reducers: {
        startLoading(state) {
            state.isLoading = true;
        },
        reservationHistoryItemsSuccess(state, action) {
            state.isLoading = false;
            state.reservationHistory = action.payload;
            state.error = null;
        },
        reservationHistoryItemsFailure(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        getTableSizes(state, action) {
            state.isLoading = false;
            state.tableSizesList = action.payload;
            state.error = null;
        },
        getTableSizesFailure(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
    },
});

export default reservationSlice.reducer;

export function getReservationHistoryByCustomerId(customerId) {
    return async (dispatch) => {
        dispatch(reservationSlice.actions.startLoading());
        try {
            const response = await api.get(
                `${process.env.REACT_APP_BACKEND_URL}/reservation/getReservationByCustomerId/b2c/${customerId}`
            );
            dispatch(reservationSlice.actions.reservationHistoryItemsSuccess(response?.data));
        } catch (error) {
            dispatch(
                reservationSlice.actions.reservationHistoryItemsFailure(
                    error.response?.data?.messags
                )
            );
        }
    };
}

export function getTableSizes(){
    return async (dispatch) => {
      dispatch(reservationSlice.actions.startLoading());
      try {
        const response = await api.get(
          `${process.env.REACT_APP_BACKEND_URL}/tables/getSizes/public`
        );
        dispatch(reservationSlice.actions.getTableSizes(response.data));
      } catch (error) {
        dispatch(
            reservationSlice.actions.getTableSizesFailure(error.response?.data?.messags)
        );
      }
    };
  }
  